/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CampaignControllerDtoCampaignListCampaignData model module.
 * @module model/CampaignControllerDtoCampaignListCampaignData
 * @version 1.0
 */
class CampaignControllerDtoCampaignListCampaignData {
    /**
     * Constructs a new <code>CampaignControllerDtoCampaignListCampaignData</code>.
     * @alias module:model/CampaignControllerDtoCampaignListCampaignData
     */
    constructor() { 
        
        CampaignControllerDtoCampaignListCampaignData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CampaignControllerDtoCampaignListCampaignData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CampaignControllerDtoCampaignListCampaignData} obj Optional instance to populate.
     * @return {module:model/CampaignControllerDtoCampaignListCampaignData} The populated <code>CampaignControllerDtoCampaignListCampaignData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CampaignControllerDtoCampaignListCampaignData();

            if (data.hasOwnProperty('campaignNo')) {
                obj['campaignNo'] = ApiClient.convertToType(data['campaignNo'], 'Number');
            }
            if (data.hasOwnProperty('campaignTitle')) {
                obj['campaignTitle'] = ApiClient.convertToType(data['campaignTitle'], 'String');
            }
            if (data.hasOwnProperty('appTitle')) {
                obj['appTitle'] = ApiClient.convertToType(data['appTitle'], 'String');
            }
            if (data.hasOwnProperty('partnerEmail')) {
                obj['partnerEmail'] = ApiClient.convertToType(data['partnerEmail'], 'String');
            }
            if (data.hasOwnProperty('startAt')) {
                obj['startAt'] = ApiClient.convertToType(data['startAt'], 'Date');
            }
            if (data.hasOwnProperty('endAt')) {
                obj['endAt'] = ApiClient.convertToType(data['endAt'], 'Date');
            }
            if (data.hasOwnProperty('isLock')) {
                obj['isLock'] = ApiClient.convertToType(data['isLock'], 'Boolean');
            }
            if (data.hasOwnProperty('region')) {
                obj['region'] = ApiClient.convertToType(data['region'], 'String');
            }
            if (data.hasOwnProperty('needMinNftGrade')) {
                obj['needMinNftGrade'] = ApiClient.convertToType(data['needMinNftGrade'], 'Number');
            }
            if (data.hasOwnProperty('needMinNftLevel')) {
                obj['needMinNftLevel'] = ApiClient.convertToType(data['needMinNftLevel'], 'Number');
            }
            if (data.hasOwnProperty('needNftType')) {
                obj['needNftType'] = ApiClient.convertToType(data['needNftType'], 'Number');
            }
            if (data.hasOwnProperty('needType')) {
                obj['needType'] = ApiClient.convertToType(data['needType'], 'Number');
            }
            if (data.hasOwnProperty('needValue')) {
                obj['needValue'] = ApiClient.convertToType(data['needValue'], 'Number');
            }
            if (data.hasOwnProperty('perOfBasicPower')) {
                obj['perOfBasicPower'] = ApiClient.convertToType(data['perOfBasicPower'], 'Number');
            }
            if (data.hasOwnProperty('xperOfBasicPower')) {
                obj['xperOfBasicPower'] = ApiClient.convertToType(data['xperOfBasicPower'], 'Number');
            }
            if (data.hasOwnProperty('perBasicPower')) {
                obj['perBasicPower'] = ApiClient.convertToType(data['perBasicPower'], 'Number');
            }
            if (data.hasOwnProperty('xperBasicPower')) {
                obj['xperBasicPower'] = ApiClient.convertToType(data['xperBasicPower'], 'Number');
            }
            if (data.hasOwnProperty('sortingIndex')) {
                obj['sortingIndex'] = ApiClient.convertToType(data['sortingIndex'], 'Number');
            }
            if (data.hasOwnProperty('usePowerDayLimit')) {
                obj['usePowerDayLimit'] = ApiClient.convertToType(data['usePowerDayLimit'], 'Number');
            }
            if (data.hasOwnProperty('depositTransactionStatus')) {
                obj['depositTransactionStatus'] = ApiClient.convertToType(data['depositTransactionStatus'], 'Number');
            }
            if (data.hasOwnProperty('x2eZone')) {
                obj['x2eZone'] = ApiClient.convertToType(data['x2eZone'], 'Boolean');
            }
            if (data.hasOwnProperty('isAdvertised')) {
                obj['isAdvertised'] = ApiClient.convertToType(data['isAdvertised'], 'Boolean');
            }
            if (data.hasOwnProperty('isEqualNftGrade')) {
                obj['isEqualNftGrade'] = ApiClient.convertToType(data['isEqualNftGrade'], 'Boolean');
            }
            if (data.hasOwnProperty('isBasicMode')) {
                obj['isBasicMode'] = ApiClient.convertToType(data['isBasicMode'], 'Boolean');
            }
            if (data.hasOwnProperty('enableStartAt')) {
                obj['enableStartAt'] = ApiClient.convertToType(data['enableStartAt'], 'String');
            }
            if (data.hasOwnProperty('enableEndAt')) {
                obj['enableEndAt'] = ApiClient.convertToType(data['enableEndAt'], 'String');
            }
            if (data.hasOwnProperty('plusFlag')) {
                obj['plusFlag'] = ApiClient.convertToType(data['plusFlag'], 'Boolean');
            }
            if (data.hasOwnProperty('ticketId')) {
                obj['ticketId'] = ApiClient.convertToType(data['ticketId'], 'Number');
            }
            if (data.hasOwnProperty('ticketCount')) {
                obj['ticketCount'] = ApiClient.convertToType(data['ticketCount'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CampaignControllerDtoCampaignListCampaignData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CampaignControllerDtoCampaignListCampaignData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['campaignTitle'] && !(typeof data['campaignTitle'] === 'string' || data['campaignTitle'] instanceof String)) {
            throw new Error("Expected the field `campaignTitle` to be a primitive type in the JSON string but got " + data['campaignTitle']);
        }
        // ensure the json data is a string
        if (data['appTitle'] && !(typeof data['appTitle'] === 'string' || data['appTitle'] instanceof String)) {
            throw new Error("Expected the field `appTitle` to be a primitive type in the JSON string but got " + data['appTitle']);
        }
        // ensure the json data is a string
        if (data['partnerEmail'] && !(typeof data['partnerEmail'] === 'string' || data['partnerEmail'] instanceof String)) {
            throw new Error("Expected the field `partnerEmail` to be a primitive type in the JSON string but got " + data['partnerEmail']);
        }
        // ensure the json data is a string
        if (data['region'] && !(typeof data['region'] === 'string' || data['region'] instanceof String)) {
            throw new Error("Expected the field `region` to be a primitive type in the JSON string but got " + data['region']);
        }
        // ensure the json data is a string
        if (data['enableStartAt'] && !(typeof data['enableStartAt'] === 'string' || data['enableStartAt'] instanceof String)) {
            throw new Error("Expected the field `enableStartAt` to be a primitive type in the JSON string but got " + data['enableStartAt']);
        }
        // ensure the json data is a string
        if (data['enableEndAt'] && !(typeof data['enableEndAt'] === 'string' || data['enableEndAt'] instanceof String)) {
            throw new Error("Expected the field `enableEndAt` to be a primitive type in the JSON string but got " + data['enableEndAt']);
        }

        return true;
    }


}



/**
 * @member {Number} campaignNo
 */
CampaignControllerDtoCampaignListCampaignData.prototype['campaignNo'] = undefined;

/**
 * @member {String} campaignTitle
 */
CampaignControllerDtoCampaignListCampaignData.prototype['campaignTitle'] = undefined;

/**
 * @member {String} appTitle
 */
CampaignControllerDtoCampaignListCampaignData.prototype['appTitle'] = undefined;

/**
 * @member {String} partnerEmail
 */
CampaignControllerDtoCampaignListCampaignData.prototype['partnerEmail'] = undefined;

/**
 * @member {Date} startAt
 */
CampaignControllerDtoCampaignListCampaignData.prototype['startAt'] = undefined;

/**
 * @member {Date} endAt
 */
CampaignControllerDtoCampaignListCampaignData.prototype['endAt'] = undefined;

/**
 * @member {Boolean} isLock
 */
CampaignControllerDtoCampaignListCampaignData.prototype['isLock'] = undefined;

/**
 * @member {String} region
 */
CampaignControllerDtoCampaignListCampaignData.prototype['region'] = undefined;

/**
 * @member {Number} needMinNftGrade
 */
CampaignControllerDtoCampaignListCampaignData.prototype['needMinNftGrade'] = undefined;

/**
 * @member {Number} needMinNftLevel
 */
CampaignControllerDtoCampaignListCampaignData.prototype['needMinNftLevel'] = undefined;

/**
 * @member {Number} needNftType
 */
CampaignControllerDtoCampaignListCampaignData.prototype['needNftType'] = undefined;

/**
 * @member {Number} needType
 */
CampaignControllerDtoCampaignListCampaignData.prototype['needType'] = undefined;

/**
 * @member {Number} needValue
 */
CampaignControllerDtoCampaignListCampaignData.prototype['needValue'] = undefined;

/**
 * @member {Number} perOfBasicPower
 */
CampaignControllerDtoCampaignListCampaignData.prototype['perOfBasicPower'] = undefined;

/**
 * @member {Number} xperOfBasicPower
 */
CampaignControllerDtoCampaignListCampaignData.prototype['xperOfBasicPower'] = undefined;

/**
 * @member {Number} perBasicPower
 */
CampaignControllerDtoCampaignListCampaignData.prototype['perBasicPower'] = undefined;

/**
 * @member {Number} xperBasicPower
 */
CampaignControllerDtoCampaignListCampaignData.prototype['xperBasicPower'] = undefined;

/**
 * @member {Number} sortingIndex
 */
CampaignControllerDtoCampaignListCampaignData.prototype['sortingIndex'] = undefined;

/**
 * @member {Number} usePowerDayLimit
 */
CampaignControllerDtoCampaignListCampaignData.prototype['usePowerDayLimit'] = undefined;

/**
 * @member {Number} depositTransactionStatus
 */
CampaignControllerDtoCampaignListCampaignData.prototype['depositTransactionStatus'] = undefined;

/**
 * @member {Boolean} x2eZone
 */
CampaignControllerDtoCampaignListCampaignData.prototype['x2eZone'] = undefined;

/**
 * @member {Boolean} isAdvertised
 */
CampaignControllerDtoCampaignListCampaignData.prototype['isAdvertised'] = undefined;

/**
 * @member {Boolean} isEqualNftGrade
 */
CampaignControllerDtoCampaignListCampaignData.prototype['isEqualNftGrade'] = undefined;

/**
 * @member {Boolean} isBasicMode
 */
CampaignControllerDtoCampaignListCampaignData.prototype['isBasicMode'] = undefined;

/**
 * @member {String} enableStartAt
 */
CampaignControllerDtoCampaignListCampaignData.prototype['enableStartAt'] = undefined;

/**
 * @member {String} enableEndAt
 */
CampaignControllerDtoCampaignListCampaignData.prototype['enableEndAt'] = undefined;

/**
 * @member {Boolean} plusFlag
 */
CampaignControllerDtoCampaignListCampaignData.prototype['plusFlag'] = undefined;

/**
 * @member {Number} ticketId
 */
CampaignControllerDtoCampaignListCampaignData.prototype['ticketId'] = undefined;

/**
 * @member {Number} ticketCount
 */
CampaignControllerDtoCampaignListCampaignData.prototype['ticketCount'] = undefined;






export default CampaignControllerDtoCampaignListCampaignData;

